import React from 'react';
import { Link } from 'react-router-dom';
import { LogIn, GraduationCap, BriefcaseBusiness, ArrowRight } from 'lucide-react';

/**
 * Quiet, professional band that points existing students and tutors to the
 * Winhouse Portal. Sits just above the footer so new visitors aren't shown
 * a login CTA above the Hero — but returning users always have a clear path.
 */
const PortalAccessSection = () => (
  <section
    className="bg-black text-white py-12 md:py-14"
    data-testid="portal-access-section"
  >
    <div className="max-w-5xl mx-auto px-6">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-start gap-4">
          <div className="h-11 w-11 rounded-xl bg-[#D3D86F] text-black flex items-center justify-center flex-shrink-0">
            <LogIn className="h-5 w-5" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[3px] text-[#D3D86F] font-bold mb-1">WINHOUSE PORTAL</div>
            <div className="text-xl md:text-2xl font-bold leading-tight">Already enrolled or teaching with Winhouse?</div>
            <div className="text-sm text-gray-300 mt-1">Sign in to view your lessons, recap PDFs, homework and student progress.</div>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2 w-full md:w-auto">
          <Link
            to="/portal/login"
            className="h-11 px-5 rounded-full bg-[#D3D86F] hover:bg-[#bdc25e] text-black text-sm font-bold uppercase tracking-wider flex items-center gap-1.5 flex-1 md:flex-none justify-center"
            data-testid="cta-portal-login"
          >
            Access Winhouse Portal <ArrowRight className="h-3.5 w-3.5" />
          </Link>
          <Link
            to="/student/login"
            className="h-11 px-4 rounded-full bg-white/10 hover:bg-white/20 text-white text-xs font-bold uppercase tracking-wider flex items-center gap-1.5"
            data-testid="cta-portal-student"
          >
            <GraduationCap className="h-3.5 w-3.5" /> Student
          </Link>
          <Link
            to="/tutor/login"
            className="h-11 px-4 rounded-full bg-white/10 hover:bg-white/20 text-white text-xs font-bold uppercase tracking-wider flex items-center gap-1.5"
            data-testid="cta-portal-tutor"
          >
            <BriefcaseBusiness className="h-3.5 w-3.5" /> Tutor
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default PortalAccessSection;
